import { useQuery } from '@tanstack/react-query';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getMySummaryOneOnOn, getMySummaryOOO } from '../services';

export const useMySummaryOneOnOne = ({
  employeeId,
  limit,
  offset,
  keepPreviousData = false,
  refetchOnWindowFocus = true,
  enabled = false,
}) =>
  useQuery(
    [REACT_QUERY_KEYS.mySummary.mySummaryOneOnOne, employeeId, limit, offset],
    () => getMySummaryOneOnOn({ employeeId, limit, offset }),
    {
      keepPreviousData,
      refetchOnWindowFocus,
      enabled,
    }
  );

export const useMySummaryOOO = ({
  employeeId,
  limit,
  offset,
  keepPreviousData = false,
  refetchOnWindowFocus = true,
  enabled = false,
}) =>
  useQuery([REACT_QUERY_KEYS.mySummary.mySummaryOOO, employeeId, limit, offset], () => getMySummaryOOO({ limit }), {
    keepPreviousData,
    refetchOnWindowFocus,
    enabled,
  });
